// @ts-strict-ignore
export class AlternativeUsageConnectionData {
  public articleUsageId: string;
  public givingConnectionName: string;

  public oldParentUsageId: string;
  public oldParentConnectionName: string;

  public newParentUsageId: string;
  public newParentConnectionName: string;

  public getConnectionNameByParentId(usageId: string): string {
    if (this.oldParentUsageId === usageId) {
      return this.oldParentConnectionName;
    } else {
      return this.newParentConnectionName;
    }
  }

  public getAlternativeParentUsageId(parentUsageId: string): string {
    if (this.oldParentUsageId === parentUsageId) {
      return this.newParentUsageId;
    } else {
      return this.oldParentUsageId;
    }
  }
}
